export default {"src":"/_next/static/media/blu-btn-play.e47ba934.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};